import { render, staticRenderFns } from "./ClientSelects.vue?vue&type=template&id=49c5a302&scoped=true&"
import script from "./ClientSelects.vue?vue&type=script&lang=js&"
export * from "./ClientSelects.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelects.vue?vue&type=style&index=0&id=49c5a302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5a302",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow,VSelect,VSpacer})
